<template>
  <v-card style="height: 120%" class="rounded-lg">
    <v-card-title
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 33px;
        font-weight: bold;
        color: #05523e;
        padding-top: 40px;
      "
    >
      Select Account
    </v-card-title>
    <v-icon class="close" size="35" @click="closeModal"
      >mdi-window-close</v-icon
    >
    <!-- search -->
    <div
      style="
        margin: 1.5% 3.5% auto;
        justify-content: center;
        align-items: center;
      "
    >
      <div
        style="
          min-width: 700px;
          display: flex;
          flex-flow: wrap;
          justify-content: start;
          align-items: center;
          height: 60px;
        "
      >
        <div style="font-size: 23px; font-weight: bold; width: 120px">
          Category
        </div>
        <v-select
          v-model="column"
          label="Category"
          :items="searchSelects"
          item-text="name"
          item-value="value"
          style="max-width: 160px; min-width: 100px"
          single-line
          color="#05523E"
        />
        <v-text-field
          v-model="search"
          clearable
          style="
            margin: auto 10px;
            max-width: 150px;
            min-width: 100px;
            height: 62px;
          "
          placeholder="Search"
          v-on:keyup.enter="searchByWord"
        />
        <v-btn
          class="white--text elevation-5 rounded-lg"
          color="#05523E"
          style="max-width: 140px; min-width: 120px; height: 35px"
          @click="searchByWord"
          >Search</v-btn
        >
      </div>
      <div v-show="isShow">
        <v-data-table
          :headers="headers"
          :items="$store.state.account.customerList"
          :page.sync="page_No"
          :items-per-page="10"
          hide-default-footer
          class="elevation-3"
          :loading="loading"
        >
          <!-- <template v-slot:header="{ props: { headers } }">
                        <thead>
                            <tr>
                                <th v-for="h in headers" v-bind:key="h.text">
                                    <span style="color: black; font-weight: bold; font-size: 17px;">{{h.text}}</span>
                                </th>
                            </tr>
                        </thead>
                    </template> -->
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.CustNum }}</td>
              <td>{{ item.Company }}</td>
              <td>{{ item.First_Name }}</td>
              <td>{{ item.Last_Name }}</td>
              <td>{{ item.Phone }}</td>
              <td>{{ item.address }}</td>
              <td>
                <v-btn
                  class="elevation-3"
                  style="
                    width: 12px;
                    margin: 0;
                    color: white;
                    background-color: #05523e;
                  "
                  @click="selectAccount(item.CustNum, item.Company)"
                >
                  <span style="font-size: 13px">Select</span>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination
            style="padding-top: 8px; padding-bottom: 20px"
            color="#05523E"
            v-model="page_No"
            :length="$store.state.account.customerPages"
            :total-visible="10"
            @input="movePage"
          />
        </div>
      </div>
      <div
        v-show="!$store.state.common.isLoading && !isShow"
        style="font-size: 20px"
      >
        <div
          style="
            margin: 0% 0% 0% 35%;
            font-size: 40px;
            color: #05523e;
            font-weight: bold;
          "
        >
          No data was retrieved.
        </div>
        <img
          style="width: 600px; height: 500px; margin: 0% 0% 0% 25%"
          src="@/assets/noData.jpg"
        />
      </div>
    </div>
  </v-card>
</template>

<script>
import { runGqlQuery } from "@/graphql/gqlUtil.js";
import { GETCUSTOMERLENGTH } from "@/graphql/AccountQueries.js";

export default {
  data() {
    return {
      searchSelects: [
        { name: "Category", value: "" },
        { name: "Cust Num", value: "CustNum" },
        { name: "Company", value: "Company" },
        { name: "First Name", value: "First_Name" },
        { name: "Last Name", value: "Last_Name" },
        { name: "Phone Number", value: "Phone" },
        { name: "Address", value: "Address" },
      ],
      column: "",
      search: "",
      page_No: 1,
      headers: [
        {
          text: "CustNum",
          align: "start",
          value: "CustNum",
          // , sort: (a, b) => a.localeCompare(b)
        },
        {
          text: "Company",
          value: "Company",
          //   sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "First_Name",
          value: "First_Name",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Last_Name",
          value: "Last_Name",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Phone",
          value: "Phone",
          //   sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Address",
          value: "address",
          sort: (a, b) => a.localeCompare(b),
        },
      ],
      categories: [
        { name: "Category", value: "", sort: (a, b) => a.localeCompare(b) },
        {
          name: "Item Number",
          value: "ItemNum",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          name: "Item Name",
          value: "ItemName",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          name: "Vendor Name",
          value: "Company",
          sort: (a, b) => a.localeCompare(b),
        },
      ],
      isShow: true,
      loading: false,
    };
  },
  async created() {
    this.loading = true;
    await this.searchCustomer();
    this.loading = false;
  },
  methods: {
    async getCustomersPage() {
      try {
        const req = { Column: this.column, Search: this.search };

        const customerPage = await runGqlQuery(GETCUSTOMERLENGTH, req);

        this.$store.state.account.customerPages = Math.ceil(
          customerPage.getCustomersLength.Length / 10
        );
      } catch (err) {
        console.error(err);
      }
    },
    async getCustomers() {
      try {
        const req = {
          Column: this.column,
          Search: this.search,
          Page_No: this.page_No - 1,
          Page_Size: 10,
        };

        await this.$store.dispatch("account/getCustomerList", req);
      } catch (err) {
        console.error(err);
      }
    },
    async searchCustomer() {
      this.loading = true;
      try {
        this.getCustomersPage();
        this.page_No = 1;
        this.getCustomers();
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    async searchByWord() {
      this.loading = true;
      try {
        if (this.column === "" && this.search === null) {
          await this.searchCustomer();
        } else if (this.column === "" && this.search !== "") {
          this.loading = false;
          return this.$store.commit("common/snackErrOn", {
            text: "Please select a category.",
          });
        }

        await this.searchCustomer();
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    async selectAccount(custNum, company) {
      this.loading = true;
      try {
        await this.$emit("selectAccount", custNum, company);
        this.closeModal();
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    async movePage(page) {
      this.loading = true;
      try {
        this.page_No = page;
        await this.getCustomers();
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    async closeModal() {
      this.$store.commit("common/changeSearchAccountModalView");
    },
  },
};
</script>

<style lang="scss" scoped>
.close {
  position: absolute;
  right: 15px;
  top: 15px;
  color: black;
}
</style>
